<template>
  <div class="surveillance-unit-list">
    <div class="panel" :class="`panel-${type}`">
      <div class="panel-heading">
        <div class="panel-title">
          <h4>
            <span class="label">
              Ufs {{ title }}
            </span>
          </h4>
        </div>
      </div>
      <div class="panel-body">
        <div v-if="units.length !== 0" class="unit-list row">
          <div v-for="(u, k) in units"
               :key="`${uid}-unit-${k}-${u.name}`">
            <div class="col-xs-6">
              <div :class="`unit-container label label-${type}`">
                <span class="unit-label text-left">
                  {{ u.name }}<br/>
                  <small>
                    {{ unitTypes.find(e => e.index === u.ufType).code }}
                  </small>
                </span>
                <btn class="close pull-right"
                     @click="remove(k)"
                     aria-label="Close">
                  <span aria-hidden="true">&times;
                  </span>
                </btn>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p>
            Veuillez ajouter une ou plusieurs UFs en utilisant le formulaire
            ci-dessous.
          </p>
        </div>
      </div>
      <div class="panel-footer">
        <div class="form-group input-group input-group-sm">
          <label class="input-group-addon" id="addon">
            &nbsp;&nbsp;&nbsp;Nom&nbsp;&nbsp;&nbsp;
          </label>
          <input required
                 id="uf"
                 v-model="uf"
                 type="text"
                 class="form-control"
                 aria-describedby="addon"
                 placeholder="UF..."/>
        </div>
        <div class="form-group input-group input-group-sm"
             v-if="!this.typeahead">
          <span class="input-group-btn">
            <dropdown ref="dropdown">
              <btn size="sm" class="dropdown-toggle">
                Type &nbsp;&nbsp;<span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-for="(f, k) in unitTypes"
                    :key="`unit-list-${k}`">
                  <a role="button"
                     @click="unitType = f">
                    {{ f.value }}
                  </a>
                </li>
              </template>
            </dropdown>
          </span>
          <span class="form-control">
            {{ unitType == null ? 'Aucun' : unitType.code }}
          </span>
        </div>
        <div v-else class="form-group">
          <div class="input-group input-group-sm">
            <label class="input-group-addon" id="addon">
              &nbsp;&nbsp;&nbsp;Type&nbsp;&nbsp;&nbsp;
            </label>
            <input required
                   ref="input"
                   id="input"
                   class="form-control"
                   v-model="text"
                   type="text"
                   placeholder="Taper le code de la spécialité..."
                   autocomplete="off"/>
          </div>
          <typeahead v-model="unitType"
                     open-on-focus
                     force-select
                     target="#input"
                     :data="unitTypes"
                     item-key="value"/>
        </div>
        <div>
          <btn :disabled="uf === '' || type == null"
               type="default"
               size="sm"
               @click="add()">
            Ajouter
          </btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'surveillance-unit-list',

  props: {
    value: {
      type: Array,
      required: true
    },

    unitTypes: {
      type: Array,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    typeahead: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      unitType: null,
      text: '',
      uf: '',
      units: this.value
    }
  },

  computed: {
    uid: function () {
      return 'unit-list-' + this._uid
    }
  },

  watch: {
    units: {
      handler () {
        this.$emit('input', this.units)
      },
      deep: true
    },

    value: function (value) {
      this.units = value
      this.unitType = null
      this.text = ''
      this.uf = ''
    },

    unitType: function (value) {
      if (value != null) {
        this.text = value.value
      }
    }
  },

  methods: {
    add: function () {
      const { unitType, uf, units } = this
      units.push({ ufType: unitType.index, name: uf })

      this.unitType = null
      this.text = ''
      this.uf = ''
    },

    remove: function (index) {
      const { units } = this
      units.splice(index, 1)

      this.unitType = null
      this.text = ''
      this.uf = ''
    }
  }
}
</script>

<style scoped lang="less">
.panel-title {
  padding-top: 0rem;
  padding-bottom: 0rem;
  .label {
    font-size: 100%;
  }
}

.panel-heading {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.input-group-addon {
  background-color: white;
}

.unit-list {
  .close {
    position: relative;
    top: 50%;
    padding: 0.3rem 0.7rem 0.5rem 0.72rem;
    font-size: 130%;
    color: white;
    opacity: 0.8;
    border-radius: 100%;

    &:hover {
      background-color: rgba(0, 0, 0, .2);
      opacity: 1;
    }
  }

  .unit-container {
    white-space: normal;
    display: inline-block;
    text-align: left;
    padding: 0.2rem;
    .unit-label {
      display: inline-block;
      max-width: 80%;
      word-break: break-all;
    }
  }

  .label {
    width: 100%;
    margin: 0.4rem 0rem;
    font-size: 100%;
    padding: 0.6rem;
    small {
      font-size: 65%;
    }
  }
}
</style>
